import type {
  CreatePricePairRequest,
  UpdatePricePairRequest,
  CreatePricePairResponse,
  GetPricePairResponse,
  UpdatePricePairResponse,
  PricePairListResponse,
  ActivePricePairResponse,
  ActivatePricePairResponse,
  DeletePricePairResponse,
} from "../types/paymentsPricePairs";
import config from "../config/config";
import axios from "../util/axios";

/**
 * Create a new payment price pair
 * @param pricePair - The price pair data to create
 */
export async function createPricePair(
  pricePair: CreatePricePairRequest,
): Promise<CreatePricePairResponse> {
  const response = await axios.post(
    `${config.defaults.api_url}/payments/price-pairs`,
    pricePair,
  );
  return response.data;
}

/**
 * Get all payment price pairs
 */
export async function getAllPricePairs(): Promise<PricePairListResponse> {
  const response = await axios.get(
    `${config.defaults.api_url}/payments/price-pairs`,
  );
  return response.data;
}

/**
 * Get the currently active price pair
 */
export async function getActivePricePair(): Promise<ActivePricePairResponse> {
  const response = await axios.get(
    `${config.defaults.api_url}/payments/price-pairs/active`,
  );
  return response.data;
}

/**
 * Get a price pair by ID
 * @param id - The price pair UUID
 */
export async function getPricePairById(
  id: string,
): Promise<GetPricePairResponse> {
  const response = await axios.get(
    `${config.defaults.api_url}/payments/price-pairs/${id}`,
  );
  return response.data;
}

/**
 * Update a price pair
 * @param id - The price pair UUID
 * @param updates - The updated price pair data
 */
export async function updatePricePair(
  id: string,
  updates: UpdatePricePairRequest,
): Promise<UpdatePricePairResponse> {
  const response = await axios.put(
    `${config.defaults.api_url}/payments/price-pairs/${id}`,
    updates,
  );
  return response.data;
}

/**
 * Delete a price pair
 * @param id - The price pair UUID
 */
export async function deletePricePair(
  id: string,
): Promise<DeletePricePairResponse> {
  const response = await axios.delete(
    `${config.defaults.api_url}/payments/price-pairs/${id}`,
  );
  return response.data;
}

/**
 * Activate a price pair (deactivates all others)
 * @param id - The price pair UUID
 */
export async function activatePricePair(
  id: string,
): Promise<ActivatePricePairResponse> {
  const response = await axios.post(
    `${config.defaults.api_url}/payments/price-pairs/${id}/activate`,
  );
  return response.data;
}
